var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('div',{staticClass:"apple-pay-button apple-pay-button-black",attrs:{"id":"applePayButton"},on:{"click":_vm.onButtonClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }